import styled, { css } from 'styled-components';
import { up } from '@/themes';

/**
 * Page-width wrapper shared by the navbar, footer and every section:
 * max-width 1280px with 16 / 24 / 32px gutters.
 */
export const SectionContainer = styled.div`
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  max-width: var(--container-max);
  padding-left: 16px;
  padding-right: 16px;
  width: 100%;

  ${up.sm} {
    padding-left: 24px;
    padding-right: 24px;
  }

  ${up.lg} {
    padding-left: 32px;
    padding-right: 32px;
  }
`;

const spacing = {
  none: css`
    padding-bottom: 0;
    padding-top: 0;
  `,
  compact: css`
    padding-bottom: 40px;
    padding-top: 40px;

    ${up.sm} {
      padding-bottom: 56px;
      padding-top: 56px;
    }
  `,
  default: css`
    padding-bottom: 64px;
    padding-top: 64px;

    ${up.sm} {
      padding-bottom: 96px;
      padding-top: 96px;
    }
  `,
};

const Outer = styled.section`
  position: relative;
  ${({ $spacing }) => spacing[$spacing] || spacing.default};

  ${({ $background }) =>
    $background &&
    css`
      background: ${$background};
    `};
`;

/**
 * A <section> with the standard vertical rhythm (64px, 96px from 640px up)
 * and a SectionContainer inside.
 *
 *   <Section id="how-it-works">…</Section>
 *   <Section $background="var(--muted)" $spacing="compact">…</Section>
 *
 * `id` doubles as the `data-section` name. Pass `containerProps` to style or
 * extend the inner container.
 */
export const Section = ({ children, containerProps, id, ...props }) => (
  <Outer id={id} data-section={id} {...props}>
    <SectionContainer {...containerProps}>{children}</SectionContainer>
  </Outer>
);
